// fallback = minimum tip in $ when (subTotal * value/100) <= fallback (e.g. 15% with fallback 3 → $20 order = $3, $10 order = $3)
export const kitchenTip = [
  { id: 1, value: 0, label: "No Tip" },
  { id: 2, value: 15, label: "15%", fallback: 3 },
  { id: 3, value: 17, label: "17%" },
  { id: 4, value: 20, label: "20%" },
];

export const driverTip = [
  { id: 1, value: 0, label: "No Tip" },
  { id: 2, value: 15, label: "15%", fallback: 3 },
  { id: 3, value: 17, label: "17%" },
  { id: 4, value: 20, label: "20%" },
];

export const marketplaceTipOptions = {
  kitchenTip,
  driverTip,
  defaultSelectedKitchenIndex: 0,
  defaultSelectedDriverIndex: 0,
};
